export default function select_r_c_b(data, r, c) {
  return data[r][c];
}